import "@popperjs/core/dist/umd/popper.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import React from 'react';
import { Location } from "@reach/router"
import { Auth0Provider } from '@auth0/auth0-react';
import { navigate } from 'gatsby';
import { RootProvider } from "./src/context/beltContext";
import { PromoProvider } from './src/context/promoContext';

const onRedirectCallback = () => {
    window.history.go(-2)
};



export const wrapRootElement = ({ element }) => {
    return (
        <Location >
            {({ location }) =>
                <Auth0Provider
                    domain={process.env.GATSBY_AUTH0_DOMAIN}
                    clientId={process.env.GATSBY_AUTH0_CLIENT_ID}
                    redirectUri={location.origin}
                    onRedirectCallback={onRedirectCallback}
                    audience={`https://${process.env.GATSBY_AUTH0_AUDIENCE}/api/v2/`}
                    scope="read:current_user update:current_user_metadata"
                >
                    <RootProvider>
                        <PromoProvider>
                            {element}
                        </PromoProvider>
                    </RootProvider>
                </Auth0Provider>}
        </Location>
    );
};
